import { useEffect, useState } from "react";
import { Grid, TextField } from "@mui/material";
import CommonDialog from "../../common/commonDialog";

const VendorDocumentReplyModal = (props) => {
  const { open, onCancel, onSave, row } = props;
  const [modenikRemarks, setModenikRemarks] = useState("");

  useEffect(() => {
    if (!open) {
      setModenikRemarks("");
    }
  }, [open]);

  const handleSubmit = () => {
    onSave?.({
      vendorDocumentUploadId:
        row?.vendorDocumentUploadId ?? row?.vendor_document_upload_id,
      modenikRemarks: modenikRemarks.trim(),
    });
  };

  return (
    <CommonDialog
      onCancel={onCancel}
      onSave={handleSubmit}
      open={open}
      primaryButtonLabel="Submit"
      secondaryButtonLabel="Close"
      title="Vendor Document"
      maxWidth="sm"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Vendor Code"
            size="small"
            value={row?.vendorCode ?? row?.vendor_code ?? ""}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Vendor Remarks"
            size="small"
            multiline
            minRows={2}
            value={row?.remarks ?? ""}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Modenik Remarks"
            size="small"
            multiline
            minRows={3}
            value={modenikRemarks}
            onChange={(e) => setModenikRemarks(e.target.value)}
            inputProps={{ maxLength: 500 }}
            required
          />
        </Grid>
      </Grid>
    </CommonDialog>
  );
};

export default VendorDocumentReplyModal;
